module.exports = __webpack_public_path__ + "img/logoseebituiutaba.5fea84d1.png";